export enum UserRole {
    GlobalAdmin = "GlobalAdmin",
    Administrator = "Administrator",
    Customer = "Customer",
    Operator = "Operator",
  }

// Numeric ids sent to the API. Must match the backend UserType enum
// (Infinitys.Portal.Business.Enums.UserType).
export const USER_TYPE_IDS: Record<UserRole, number> = {
  [UserRole.GlobalAdmin]: 1,
  [UserRole.Customer]: 2,
  [UserRole.Operator]: 3,
  [UserRole.Administrator]: 4,
};

export const getUserTypeId = (
  type?: string | number | null
): number | undefined =>
  typeof type === "number" ? type : USER_TYPE_IDS[type as UserRole];
